import React from 'react';
import { clsx } from 'clsx';

const Card = ({ 
  children, 
  className = "", 
  hover = false, 
  padding = "default",
  ...props 
}) => {
  const baseClasses = "bg-white rounded-xl shadow-lg border border-gray-100";
  
  const paddingClasses = {
    none: "",
    sm: "p-4",
    default: "p-6",
    lg: "p-8"
  };

  const classes = clsx(
    baseClasses,
    paddingClasses[padding],
    {
      'card-hover': hover,
    },
    className
  );

  return (
    <div className={classes} {...props}>
      {children}
    </div>
  );
};

export default Card;